<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-07-21 14:52:34
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-07-21 16:00:27
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/ES/ESapply/component/auditForm.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- 评价机构审核信息 -->
<template>
  <div>
    <el-row>
      <el-col :span="12">
        <el-form ref="form" :rules="rules" :model="form" label-width="80px">
          <el-form-item label="审核结果" prop="result">
            <el-radio-group v-model="form.result">
              <el-radio :label="1">通过</el-radio>
              <el-radio :label="2">驳回</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="审核意见"
            prop="remark"
            :rules="form.result === 2 ? rules.remark : [{ required: false }]"
          >
            <el-input
              type="textarea"
              maxlength="500"
              show-word-limit
              v-model="form.remark"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    applyInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      form: {
        result: 1,
        remark: ''
      },
      rules: {
        result: [
          { required: true, message: '请选择审核结果', trigger: 'change' }
        ],
        remark: [
          {
            required: true,
            message: '请填写审核意见',
            trigger: ['blur', 'change']
          }
        ]
      }
    };
  },

  components: {},

  computed: {},

  created() {
    this.form = { ...this.applyInfo };
  },
  methods: {
    submitForm(callback) {
      this.$refs['form'].validate(valid => {
        if (valid) {
          callback(this.form);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped></style>
